module.exports = __webpack_public_path__ + "img/jtbank.8dcbe4fe.png";